export const navUrls = {
  root: '',
  pileTurnerSelection: 'pile-turner',
  pileTurner: ''
};
